/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InfoChartComponent} from './info-chart.component';
import {PipesModule} from '../pipes/pipes.module';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [InfoChartComponent],
    imports: [
        CommonModule,
        PipesModule,
        TooltipModule
    ],
    exports: [InfoChartComponent]
})
export class InfoChartModule {
}
